import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import localforage from "localforage";
import { useLazyQuery } from "@apollo/client";

import "./Callback.scss";
import * as Storage from "../../service/storage";
import { logout } from "../../service/graphql/utils";
import { azureAuthenticate } from "../../service/utils/functions";
import { GET_USER_PAGE_PERMISSIONS } from "../../service/graphql/auth";
import { setMatomoUser } from "../../service/matomo";

const Callback = () => {
  const navigate = useNavigate();
  const [urlParams] = useSearchParams();
  const [accessToken, setAccessToken] = useState<string>();
  const [displayErrorMsg, setDisplayErrorMsg] = useState<string>();

  const [getUserPagePermissions] = useLazyQuery(GET_USER_PAGE_PERMISSIONS);

  useEffect(() => {
    const token = urlParams.get("access_token");
    if (token) {
      window.history.replaceState(
        null,
        "",
        `/auth/microsoft/callback?${urlParams.toString()}`
      );
      setAccessToken(token);
    } else setDisplayErrorMsg("Undefined access code");
  }, [urlParams]);

  useEffect(() => {
    if (accessToken && accessToken.length > 0) {
      azureAuthenticate(accessToken)
        .then((res) => {
          Storage.TOKEN.set(res.jwt);
          setMatomoUser(res.user.email, "Microsoft SSO");
          getUserPagePermissions({
            variables: { id: res.user.id },
            context: { apiName: "cms" },
          }).then((userPermissionData: any) => {
            const permissionsTable =
              userPermissionData.data?.userDetails?.data[0]?.attributes
                .page_permissions;
            localforage
              .setItem("userData", {
                name: res.user.email,
                email: res.user.email,
                page_permissions: permissionsTable,
              })
              .then(() => {
                window.history.replaceState(null, "", "/");
                navigate("/dashboard/home");
              });
          });
        })
        .catch((err) => {
          console.error(err);
          setDisplayErrorMsg(
            "Authentication via Microsoft SSO failed: " + err.message
          );
          setTimeout(() => logout(navigate), 5000);
        });
    }
  }, [navigate, getUserPagePermissions, accessToken]);

  return (
    <div className="screen-bg">
      <h1>
        {displayErrorMsg && displayErrorMsg.length > 0
          ? displayErrorMsg
          : "Redirecting, please wait..."}
      </h1>
    </div>
  );
};

export default Callback;
